<template>
  <div>
    <!-- 底部导航栏 -->
    <div class="bottom-info">
      <div class="bottom-nav-box flex flex-y-s pb-60">
        <!-- 网站地图 -->
        <div class=" pt-50 flex flex-x-s flex-y-s">
          <div class="nav-map">
            <p class="f-16 mb-15 c-ff shou"
              @click.stop="bindlinkTo('/about?id=' + about_list[0].id, about_list[0].SYS_TOPIC)">关于我们</p>
            <!-- <router-link v-for="item,index in about_list" :key="index" :to="{name: 'about',query: {id: item.id}}" class="f-14 link mt-10 flex">{{item.SYS_TOPIC}}</router-link> -->

            <div v-for="item, index in about_list" :key="index" class="f-14 link mt-10 flex shou"
              @click.stop="bindlinkTo('/about?id=' + item.id, item.SYS_TOPIC)">{{ item.SYS_TOPIC }}</div>
          </div>
          <div class="nav-map">
            <p class="f-16 mb-15 c-ff">图片</p>
            <div class="f-14 link mt-10 flex shou" @click.stop="bindlinkTo('/img_list?cats=29253&navid=88', '历史图片')">
              历史图片
            </div>
            <div class="f-14 link mt-10 flex shou" @click.stop="bindlinkTo('/img_list?cats=13614&navid=110', '新闻图片')">
              新闻图片</div>
            <div class="f-14 link mt-10 flex shou" @click.stop="bindlinkTo('/img_list?cats=168715&navid=111', '美好安徽')">
              美好安徽</div>
            <div class="f-14 link mt-10 flex shou" @click.stop="bindlinkTo('/img_list?cats=195917&navid=112', '设计素材')">
              设计素材</div>
            <div class="f-14 link mt-10 flex shou" @click.stop="bindlinkTo('/special_list?navid=113', '专题图片')">专题图片
            </div>
          </div>

          <div class="nav-map">
            <p class="f-16 mb-15 c-ff">视频</p>
            <div v-for="item, index in bottom_sp" :key="index" class="f-14 link mt-10 flex shou"
              @click.stop="bindlinkTo(item.url, item.name)">{{ item.name }}</div>
          </div>
          <div class="nav-map">
            <p class="f-16 mb-15 c-ff">音频</p>
            <div v-for="item, index in bottom_yp" :key="index" class="f-14 link mt-10 flex shou"
              @click.stop="bindlinkTo(item.url, item.name)">{{ item.name }}</div>

          </div>
        </div>
        <!-- 二维码-信息 -->
        <div class="code-info-box flex-box pt-40 flex flex-y-s flex-x-s" v-if="typeName == 'hlwuhu'">
          <div class="qr-box flex-c"><img src="../assets/images/wuh.png" alt=""></div>
          <div class="ml-40 f-14 c-ff flex-box">
            <div class="mt-10">版权所有: 芜湖市文化和旅游局</div>

            <!-- <div class="mt-30">版权声明: 所有图文素材均受著作权保护，未经许可不得使用，不得转载， 摘编。如果您侵犯了该影像作品的知识产权，版权所有人有权依据著作权侵权惩罚性赔偿标准或最高达50万元人民币的法定标准，而不依据本站标注授权价格，向你提起赔要求</div> -->
          </div>
        </div>
        <div class="code-info-box flex-box pt-40 flex flex-y-s flex-x-s" v-if="typeName == 'sutpk'">
          <div class="qr-box flex-c"><img src="../assets/images/suzhou.png" alt=""></div>
          <div class="ml-40 f-14 c-ff flex-box">
            <div class="mt-10">版权所有: 中共宿州市委宣传部</div>

            <!-- <div class="mt-30">版权声明: 所有图文素材均受著作权保护，未经许可不得使用，不得转载， 摘编。如果您侵犯了该影像作品的知识产权，版权所有人有权依据著作权侵权惩罚性赔偿标准或最高达50万元人民币的法定标准，而不依据本站标注授权价格，向你提起赔要求</div> -->
          </div>
        </div>
        <div class="code-info-box flex-box pt-40 flex flex-y-s flex-x-s" v-if="typeName == ''">
          <div class="qr-box flex-c"><img src="../assets/images/code-ex.png" alt=""></div>
          <div class="ml-40 f-14 c-ff flex-box">
            <div class="mt-10">版权所有: 安徽画报社</div>
            <div class="mt-10">联系人: 张先生</div>
            <div class="mt-10">热线: 0551-64376913</div>
            <div class="mt-10">邮箱: 25783311@qq.com</div>
            <div class="mt-10">地址: 安徽省合肥市高新区黄山路599号时代数码港24F</div>
            <!-- <div class="mt-30">版权声明: 所有图文素材均受著作权保护，未经许可不得使用，不得转载， 摘编。如果您侵犯了该影像作品的知识产权，版权所有人有权依据著作权侵权惩罚性赔偿标准或最高达50万元人民币的法定标准，而不依据本站标注授权价格，向你提起赔要求</div> -->
          </div>
        </div>

      </div>
      <div class="bottom-nav-box banq t-c">安徽画报 版权所有 2021 <a href="https://beian.miit.gov.cn"
          style="color:#959595 !important;" target="_blank">皖ICP备10200519号-11</a> Powered by 图片安徽 　广告热线/传真：0551-64376898
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      about_list: [],
      bottom_sp: [],
      bottom_yp: [],
      pic_cates: [],
      typeName: ''
    }
  },

  created() {
    this.bindBottom() // 获取底部资料
    this.bindBottomvideo()
    this.bindBottommusic()
    this.bindCaterec()
    if (this.$route.query.type == 'sutpk' || this.$route.name == 'sutpk') {
      this.typeName = 'sutpk'
    } else if (this.$route.query.type == 'hlwuhu' || this.$route.name == 'hlwuhu') {
      this.typeName = 'hlwuhu'
      console.log(this.typeName)
    }
  },

  methods: {

    // 推荐图片分类的不同专题
    async bindCaterec() {
      let _this = this
      const res = await _this.post('/spc/cms/col/getColNextLevelNode?colId=18', {})
      if (res.data.length) {
        res.data.forEach(x => {
          let index = x.url.indexOf('?')
          x.params = x.url.substr(index + 1)
        })
        _this.pic_cates = res.data
        // _this.pic_navindex = 0
      }
    },


    // 获取尾部关于我们部分
    async bindBottom() {
      let _this = this
      let data = {
        conditions: JSON.stringify([{ pub_col_id: 82 }, { pub_sale_status: 1 }]),
        orderBy: "pub_a_order asc pub_lastmodified desc id asc",
        pageNo: 1,
        pageSize: 15,
        searchText: "",
      }
      const res = await _this.post('/spc/cms/publish/list.do', data)
      if (res.success) {
        _this.about_list = res.result
      } else {
        _this.$Message.error(res.description);
      }
    },
    // 获取尾部关于我们部分
    // async bindBottom () {
    // 		 let _this = this
    // 		 const res = await _this.post('/spc/cms/col/getColNextLevelNode?colId=82',{})
    // 		 if (res.data.length) {
    // 				 _this.about_list = res.data
    // 		 }
    // },
    // 获取尾部视频分类部分
    async bindBottomvideo() {
      let _this = this
      const res = await _this.post('/spc/cms/col/getColNextLevelNode?colId=47', {})
      if (res.data.length) {
        _this.bottom_sp = res.data
      }
    },
    // 获取尾部视频分类部分
    async bindBottommusic() {
      let _this = this
      const res = await _this.post('/spc/cms/col/getColNextLevelNode?colId=51', {})
      if (res.data.length) {
        _this.bottom_yp = res.data
      }
    },

    // 跳转
    bindlinkTo(path, name) {
      if (path == '/index') {
        this.$router.push({ path, query: { name } })
      } else {
        let link = this.$router.resolve({
          path, //要跳转的路由
          query: {
            name
          }
        });
        window.open(link.href, "_blank"); //打开新窗口
      }
    },

  }
}
</script>

<style lang="less" scoped="">
// 底部版权
.bottom-info {
  background-color: #353535;

  .bottom-nav-box {
    width: 1200px;
    margin: 0 auto;
  }

  .bottom-nav-box.banq {
    height: 30px;
    line-height: 30px;
    color: #959595;
    border-top: 1px solid #4a4a4a;
  }

  .nav-map {
    padding: 3px 70px 3px 20px;
    border-left: 1px solid #4a4a4a;

    .link {
      color: #959595 !important;
    }
  }

  .code-info-box {
    margin-left: 130px;

    .qr-box {
      width: 120px;
      height: 120px;
      border: 1px solid #606060;
    }

    img {
      width: 106px;
      height: 106px;
    }
  }
}
</style>
